module.exports = __webpack_public_path__ + "static/media/24 CAD stations@2x.fb659bc0.jpg";